interface SignupWallCopy {
  heading: string
  subheading?: string
  checklistItems: string[]
}

export const getSignupWallCopy = (): SignupWallCopy => {
  return {
    heading: 'Get Grammarly for free to get more',
    checklistItems: ['Instant proofreading', 'Generative AI assistance', 'Tone and clarity suggestions'],
  }
}
